import React, { Component } from 'react';
import Icon from '../../Icon';
import { NavLink } from 'react-router-dom';
import './styles.scss';

class AdminNavigationItem extends Component {
	render() {
		const { to, title, counter, note, icon, theme } = this.props;

		let themeClass = '';

		switch (theme) {
		case 'orange':
			themeClass = 'AdminNavigationItem--orange';
			break;
		case 'blue':
			themeClass = 'AdminNavigationItem--blue';
			break;
		case 'salmon':
			themeClass = 'AdminNavigationItem--salmon';
			break;
		default:
			themeClass = '';
		}

		const AdminNavigationItemClass = ['AdminNavigationItem', themeClass].join(
			' '
		);

		return (
			<NavLink
				className={AdminNavigationItemClass}
				activeClassName="is-active"
				to={to}
			>
				<div className="AdminNavigationItem-content">
					<div className="AdminNavigationItem-icon">
						<Icon icon={icon} />
					</div>
					<div className="AdminNavigationItem-info">
						<h3 className="AdminNavigationItem-title">{title}</h3>
						<span className="AdminNavigationItem-counter">{counter}</span>
						<small className="AdminNavigationItem-note">{note}</small>
					</div>
				</div>
				{/*
					lastTracked &&
						<div className="AdminNavigationItem-lastTracked">
							<span>{ lastTracked.label }</span>
							<span>{ lastTracked.name }</span>
							<span>{ lastTracked.team }</span>
							<span>{ lastTracked.date }</span>
						</div>
				*/}
			</NavLink>
		);
	}
}

export default AdminNavigationItem;
